{
  "badge": "إدارة المنصة",
  "consoleName": "لوحة إدارة منصة سحاب",
  "nav": {
    "label": "لوحة الإدارة",
    "menu": "القائمة",
    "tenants": "الشركات",
    "dashboard": "لوحة المعلومات",
    "subscriptions": "الاشتراكات",
    "feedback": "الملاحظات"
  },
  "admin": {
    "menu": "قائمة حساب {{name}}",
    "profile": "الملف الشخصي",
    "signOut": "تسجيل الخروج",
    "signedOut": "تم تسجيل الخروج من لوحة الإدارة",
    "roles": {
      "OWNER": "مالك",
      "ADMIN": "مسؤول",
      "SUPPORT": "دعم فني"
    }
  },
  "login": {
    "title": "لوحة إدارة المنصة",
    "subtitle": "لمشغّلي سحاب فقط. يسجّل مستخدمو الشركات الدخول من مساحة عمل شركتهم.",
    "help": "فقدت الوصول؟ يمكن لمالك آخر إعادة تعيين كلمة مرورك من سطر أوامر المشغّلين.",
    "errors": {
      "invalidCredentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة. تحقّق منهما وحاول مرة أخرى.",
      "rateLimited": "محاولات تسجيل دخول كثيرة من هذه الشبكة. انتظر دقيقة ثم حاول مرة أخرى.",
      "disabled": "لوحة إدارة المنصة غير مُعدّة على هذا الخادم.",
      "invalidInput": "أدخل بريدك الإلكتروني وكلمة المرور."
    },
    "hub": {
      "button": "تسجيل الدخول عبر cloudTech Hub",
      "or": "أو بكلمة المرور",
      "only": "يسجّل المشرفون العامّون الدخول عبر cloudTech Hub على هذا الخادم.",
      "none": "تسجيل الدخول بكلمة المرور متوقف، وcloudTech Hub غير مُعدّ على هذا الخادم.",
      "errors": {
        "noSuperAdmin": "لا يوجد لحسابك في cloudTech حساب مشرف عام نشط هنا. يمكن لمالك إضافته بالبريد الإلكتروني نفسه من سطر أوامر المشغّلين.",
        "notMfa": "لم يؤكّد cloudTech Hub عاملًا ثانيًا للتحقق. سجّل الدخول إلى Hub مرة أخرى.",
        "state": "انتهت صلاحية رابط تسجيل الدخول هذا أو سبق استخدامه. حاول مرة أخرى.",
        "hubDenied": "لم يسجّل cloudTech Hub دخولك.",
        "notConfigured": "تسجيل الدخول عبر cloudTech Hub غير مُعدّ على هذا الخادم.",
        "failed": "تعذّر تسجيل الدخول عبر cloudTech Hub. حاول مرة أخرى."
      }
    }
  },
  "errors": {
    "backToTenants": "العودة إلى الشركات",
    "tenantNotFound": "الشركة غير موجودة",
    "tenantNotFoundBody": "ربما حُذفت، أو أن العنوان غير صحيح."
  },
  "conflict": {
    "title": "حفظ شخص آخر قبلك",
    "body": "لم تُحفظ تغييراتك. حمّل أحدث نسخة ثم أعد إجراء تغييراتك.",
    "reload": "تحميل أحدث نسخة"
  },
  "profile": {
    "title": "ملفك الشخصي",
    "details": "الاسم والبريد الإلكتروني",
    "name": "الاسم",
    "email": "البريد الإلكتروني",
    "currentPassword": "كلمة المرور الحالية",
    "currentPasswordHint": "تغيير البريد الإلكتروني الذي تسجّل الدخول به يتطلب كلمة مرورك.",
    "currentPasswordNeeded": "أدخل كلمة مرورك الحالية لتغيير بريدك الإلكتروني.",
    "currentPasswordWrong": "كلمة المرور الحالية غير صحيحة.",
    "emailTaken": "هذا البريد الإلكتروني مستخدم لدى مشغّل آخر.",
    "saved": "تم حفظ الملف الشخصي",
    "discard": "تجاهل التغييرات",
    "save": "حفظ الملف الشخصي",
    "passwordBody": "كلمة المرور التي تسجّل بها الدخول إلى لوحة الإدارة."
  },
  "status": {
    "ACTIVE": "نشطة",
    "SUSPENDED": "موقوفة"
  },
  "fields": {
    "slug": "معرّف مساحة العمل",
    "slugHint": "من 1 إلى 40 حرفًا لاتينيًا صغيرًا أو رقمًا أو شرطة. لا يمكن تغييره لاحقًا.",
    "slugOk": "صيغة صحيحة:",
    "slugFormat": "استخدم من 1 إلى 40 حرفًا لاتينيًا صغيرًا أو رقمًا أو شرطة، يبدأ وينتهي بحرف أو رقم.",
    "slugReserved": "هذا الاسم محجوز للخدمة. اختر اسمًا آخر.",
    "name": "اسم الشركة",
    "nameAr": "اسم الشركة (بالعربية)",
    "defaultLocale": "اللغة الافتراضية",
    "defaultLocaleHint": "للمستخدمين الجدد والمستندات المطبوعة للشركة.",
    "languages": {
      "en": "الإنجليزية",
      "ar": "العربية"
    },
    "status": "الحالة",
    "modules": "الوحدات",
    "activeUsers": "المستخدمون النشطون",
    "lastSignIn": "آخر تسجيل دخول",
    "created": "تاريخ الإنشاء",
    "adminName": "الاسم",
    "adminEmail": "البريد الإلكتروني",
    "adminPassword": "كلمة المرور",
    "adminPasswordHint": "10 أحرف على الأقل. شاركها مع المسؤول بطريقة آمنة، ويمكنه تغييرها لاحقًا.",
    "showPassword": "إظهار كلمة المرور",
    "hidePassword": "إخفاء كلمة المرور"
  },
  "create": {
    "title": "شركة جديدة",
    "subtitle": "شركة على سحاب، بمستخدميها ودفاترها الخاصة.",
    "blocks": {
      "company": "الشركة",
      "legal": "البيانات القانونية",
      "legalBody": "تُطبع في رأس فواتير الشركة ومستنداتها. يمكن للشركة تغييرها من الإعدادات.",
      "modules": "الوحدات",
      "modulesBody": "ما يمكن للشركة استخدامه. الوحدات المعطّلة تُخفى عن مستخدميها.",
      "admin": "المسؤول الأول",
      "adminBody": "يسجّل الدخول بجميع الصلاحيات ويدعو بقية الفريق.",
      "residency": "موقع البيانات",
      "residencyBody": "مكان حفظ ملفات الشركة وبياناتها، ولا يتغير لاحقًا إلا بنقل البيانات."
    },
    "submit": "إنشاء الشركة",
    "failed": "لم تُنشأ الشركة",
    "done": "تم إنشاء {{name}}",
    "slugTaken": "معرّف مساحة العمل هذا مستخدم لدى شركة أخرى.",
    "emailTaken": "هذا البريد الإلكتروني مسجّل لمستخدم آخر. استخدم بريدًا آخر.",
    "confirmTitle": "إنشاء الشركة دون هذه الوحدات؟",
    "confirmBody": "بعض الوحدات المختارة تعتمد على وحدات لم تُختر (انظر التنبيهات). يمكنك تفعيل الوحدات لاحقًا من تبويب الوحدات في صفحة الشركة.",
    "confirmCreate": "إنشاء على أي حال"
  },
  "list": {
    "title": "الشركات",
    "count_zero": "لا توجد شركات",
    "count_one": "شركة واحدة",
    "count_two": "شركتان",
    "count_few": "{{n}} شركات",
    "count_many": "{{n}} شركة",
    "count_other": "{{n}} شركة",
    "modulesOf": "{{n}} من {{total}}",
    "new": "شركة جديدة",
    "searchPlaceholder": "ابحث بالاسم أو معرّف مساحة العمل…",
    "searchLabel": "البحث في الشركات",
    "clearSearch": "مسح البحث",
    "statusFilter": "الحالة",
    "allStatuses": "كل الحالات",
    "tableLabel": "الشركات",
    "clearFilters": "مسح عوامل التصفية",
    "empty": {
      "title": "لا توجد شركات بعد",
      "body": "أضف أول شركة إلى الخدمة.",
      "filteredTitle": "لا توجد شركات مطابقة",
      "filteredBody": "جرّب بحثًا أو حالة أخرى."
    }
  },
  "detail": {
    "created": "أُنشئت في {{date}}",
    "suspend": "إيقاف",
    "activate": "تفعيل",
    "suspendTitle": "إيقاف {{name}}؟",
    "suspendBody": "يُسجَّل خروج جميع المستخدمين فورًا ولا يمكن لأحد تسجيل الدخول حتى تُفعَّل الشركة من جديد. تبقى بياناتها محفوظة.",
    "activateTitle": "تفعيل {{name}}؟",
    "activateBody": "يمكن لمستخدمي الشركة تسجيل الدخول مجددًا.",
    "reason": "السبب",
    "reasonHint": "يُحفظ في سجل نشاط المشغّلين.",
    "suspended": "تم إيقاف {{name}}",
    "activated": "تم تفعيل {{name}}",
    "suspendedNotice": "هذه الشركة موقوفة: لا يمكن لمستخدميها تسجيل الدخول.",
    "profileSaved": "تم حفظ بيانات الشركة",
    "saveProfile": "حفظ البيانات",
    "tabs": {
      "label": "الشركة",
      "profile": "البيانات",
      "modules": "الوحدات",
      "users": "المستخدمون",
      "activity": "النشاط",
      "subscriptions": "الاشتراكات",
      "residency": "موقع البيانات"
    }
  },
  "modules": {
    "title": "الوحدات",
    "body": "ما يمكن للشركة استخدامه. تعطيل وحدة يخفيها عن جميع المستخدمين، وتبقى بياناتها محفوظة.",
    "ownerOnly": "لا يغيّر وحدات الشركة إلا المالك.",
    "needs": "تحتاج إلى {{modules}}",
    "worksBestWith": "تعمل بشكل أفضل مع {{modules}}",
    "lostNeeds": "تحتاج وحدة {{module}} إلى وحدة {{dependency}}. {{reason}}.",
    "lostUses": "تعمل وحدة {{module}} بشكل أفضل مع وحدة {{dependency}}. {{reason}}.",
    "workflowsOnHold_zero": "لا توجد طلبات اعتماد قيد التنفيذ.",
    "workflowsOnHold_one": "يوجد طلب اعتماد واحد قيد التنفيذ. سيُعلَّق — ويبقى مستنده مقفلًا — حتى يُعاد تفعيل مسارات الاعتماد.",
    "workflowsOnHold_two": "يوجد طلبا اعتماد قيد التنفيذ. سيُعلَّقان — ويبقى مستنداهما مقفلَين — حتى يُعاد تفعيل مسارات الاعتماد.",
    "workflowsOnHold_few": "توجد {{n}} طلبات اعتماد قيد التنفيذ. ستُعلَّق — وتبقى مستنداتها مقفلة — حتى يُعاد تفعيل مسارات الاعتماد.",
    "workflowsOnHold_many": "يوجد {{n}} طلبًا للاعتماد قيد التنفيذ. ستُعلَّق — وتبقى مستنداتها مقفلة — حتى يُعاد تفعيل مسارات الاعتماد.",
    "workflowsOnHold_other": "يوجد {{n}} طلب اعتماد قيد التنفيذ. ستُعلَّق — وتبقى مستنداتها مقفلة — حتى يُعاد تفعيل مسارات الاعتماد.",
    "subjectModuleOnHold_zero": "لا توجد طلبات اعتماد قيد التنفيذ.",
    "subjectModuleOnHold_one": "يوجد طلب اعتماد واحد قيد التنفيذ. سينتظر — ويبقى مستنده مقفلًا — حتى يُعاد تفعيل {{module}}.",
    "subjectModuleOnHold_two": "يوجد طلبا اعتماد قيد التنفيذ. سينتظران — ويبقى مستنداهما مقفلَين — حتى يُعاد تفعيل {{module}}.",
    "subjectModuleOnHold_few": "توجد {{n}} طلبات اعتماد قيد التنفيذ. ستنتظر — وتبقى مستنداتها مقفلة — حتى يُعاد تفعيل {{module}}.",
    "subjectModuleOnHold_many": "يوجد {{n}} طلبًا للاعتماد قيد التنفيذ. ستنتظر — وتبقى مستنداتها مقفلة — حتى يُعاد تفعيل {{module}}.",
    "subjectModuleOnHold_other": "يوجد {{n}} طلب اعتماد قيد التنفيذ. ستنتظر — وتبقى مستنداتها مقفلة — حتى يُعاد تفعيل {{module}}.",
    "shiftsOpen_zero": "لا توجد ورديات مفتوحة في نقاط البيع.",
    "shiftsOpen_one": "توجد وردية واحدة مفتوحة في نقاط البيع. لا يمكن جردها أو إغلاقها حتى يُعاد تفعيل نقاط البيع، فيبقى نقدها دون جرد. اطلب من الكاشير إغلاقها أولًا.",
    "shiftsOpen_two": "توجد ورديتان مفتوحتان في نقاط البيع. لا يمكن جردهما أو إغلاقهما حتى يُعاد تفعيل نقاط البيع، فيبقى نقدهما دون جرد. اطلب من الكاشيرَين إغلاقهما أولًا.",
    "shiftsOpen_few": "توجد {{n}} ورديات مفتوحة في نقاط البيع. لا يمكن جردها أو إغلاقها حتى يُعاد تفعيل نقاط البيع، فيبقى نقدها دون جرد. اطلب من الكاشيرين إغلاقها أولًا.",
    "shiftsOpen_many": "توجد {{n}} وردية مفتوحة في نقاط البيع. لا يمكن جردها أو إغلاقها حتى يُعاد تفعيل نقاط البيع، فيبقى نقدها دون جرد. اطلب من الكاشيرين إغلاقها أولًا.",
    "shiftsOpen_other": "توجد {{n}} وردية مفتوحة في نقاط البيع. لا يمكن جردها أو إغلاقها حتى يُعاد تفعيل نقاط البيع، فيبقى نقدها دون جرد. اطلب من الكاشيرين إغلاقها أولًا.",
    "collectionsUnverified_zero": "لا توجد مبالغ أبلغ عنها الفنيون بانتظار الاعتماد.",
    "collectionsUnverified_one": "يوجد مبلغ واحد أبلغ عنه الفنيون بانتظار الاعتماد. لا يمكن اعتماده سندَ قبض حتى تكون وحدتا الخدمة والمبيعات مفعّلتين.",
    "collectionsUnverified_two": "يوجد مبلغان أبلغ عنهما الفنيون بانتظار الاعتماد. لا يمكن اعتمادهما سندَي قبض حتى تكون وحدتا الخدمة والمبيعات مفعّلتين.",
    "collectionsUnverified_few": "توجد {{n}} مبالغ أبلغ عنها الفنيون بانتظار الاعتماد. لا يمكن اعتمادها سندات قبض حتى تكون وحدتا الخدمة والمبيعات مفعّلتين.",
    "collectionsUnverified_many": "يوجد {{n}} مبلغًا أبلغ عنها الفنيون بانتظار الاعتماد. لا يمكن اعتمادها سندات قبض حتى تكون وحدتا الخدمة والمبيعات مفعّلتين.",
    "collectionsUnverified_other": "يوجد {{n}} مبلغ أبلغ عنها الفنيون بانتظار الاعتماد. لا يمكن اعتمادها سندات قبض حتى تكون وحدتا الخدمة والمبيعات مفعّلتين.",
    "accountingLockDate": "الدفاتر مقفلة حتى {{date}}. ما دامت المحاسبة معطّلة لا يمكن لأحد في الشركة تغيير هذا التاريخ، فلا يمكن ترحيل أو إلغاء أي مستند مؤرخ فيه أو قبله.",
    "accountingFiscalYear": "تنتهي آخر سنة مالية في {{date}}. تُضاف السنوات التالية تلقائيًا، اثنا عشر شهرًا لكل منها، لكن لا يمكن لأحد في الشركة إقفال سنة أو إعادة فتحها ما دامت المحاسبة معطّلة.",
    "save": "حفظ الوحدات",
    "saved": "تم حفظ الوحدات",
    "confirmTitle": "حفظ الوحدات رغم التنبيهات؟",
    "confirmBody": "تحتفظ الشركة ببياناتها، وإعادة تفعيل الوحدة تعيدها كما كانت. تنطبق التنبيهات أعلاه حتى ذلك الحين.",
    "confirmSave": "حفظ على أي حال"
  },
  "users": {
    "tableLabel": "المستخدمون",
    "name": "الاسم",
    "roles": "الأدوار",
    "status": "الحالة",
    "statuses": {
      "ACTIVE": "نشط",
      "DISABLED": "معطّل"
    },
    "locked": "مقفل",
    "lockedUntil": "مقفل بعد محاولات دخول فاشلة حتى {{date}}",
    "mustChange": "يجب تغيير كلمة المرور",
    "actions": "الإجراءات",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "resetTitle": "إعادة تعيين كلمة مرور {{name}}",
    "resetBody": "اكتب كلمة مرور جديدة وأعطها للمستخدم. يسجّل الدخول بها كما هي، ويمكنه تغييرها لاحقًا.",
    "newPasswordHint": "10 أحرف على الأقل. شاركها مع المستخدم بطريقة آمنة.",
    "newPassword": "كلمة المرور الجديدة",
    "resetSubmit": "إعادة تعيين كلمة المرور",
    "resetDone": "تمت إعادة تعيين كلمة مرور {{name}}",
    "resetDoneBody": "تم تسجيل خروجه من جلساته المفتوحة. يسجّل الدخول بكلمة المرور الجديدة.",
    "empty": "لا يوجد مستخدمون لهذه الشركة.",
    "signInAs": "الدخول باسمه",
    "signInAsTitle": "الدخول باسم {{name}}",
    "signInAsSubmit": "فتح تطبيق الشركة",
    "signInAsHour": "يُفتح تطبيق الشركة في هذا المتصفح باسم {{email}} لمدة ساعة واحدة كحد أقصى.",
    "signInAsAudit": "يُسجَّل ذلك مع السبب في سجل المشغّلين وفي سجل التدقيق الخاص بالشركة.",
    "signInAsReplaces": "يُسجَّل خروج أي جلسة شركة مفتوحة في هذا المتصفح.",
    "signInAsReasonHint": "مثلًا: طلب الدعم الذي تعمل عليه."
  },
  "activity": {
    "label": "نشاط المشغّلين",
    "empty": "لا يوجد نشاط للمشغّلين على هذه الشركة بعد.",
    "by": "بواسطة {{name}}",
    "actions": {
      "tenant_create": "إنشاء الشركة",
      "tenant_update": "تغيير البيانات",
      "tenant_suspend": "إيقاف الشركة",
      "tenant_activate": "تفعيل الشركة",
      "modules_set": "تغيير الوحدات",
      "user_password_reset": "إعادة تعيين كلمة مرور مستخدم",
      "user_impersonate": "الدخول باسم مستخدم",
      "subscription_create": "إضافة اشتراك",
      "subscription_update": "تعديل اشتراك",
      "subscription_cancel": "إلغاء اشتراك",
      "feedback_update": "تحديث ملاحظة",
      "auth_login": "تسجيل دخول",
      "auth_logout": "تسجيل خروج",
      "auth_login_failed": "محاولة دخول فاشلة",
      "admin_profile_update": "تغيير الملف الشخصي",
      "admin_password_change": "تغيير كلمة المرور",
      "admin_create": "إضافة مشرف عام",
      "admin_reset": "إعادة تعيين مشرف عام",
      "admin_disable": "إيقاف مشرف عام"
    }
  },
  "dashboard": {
    "title": "لوحة المعلومات",
    "figures": "أرقام الخدمة",
    "activeCompanies": "الشركات النشطة",
    "suspended": "{{n}} موقوفة",
    "newCompanies": "شركات جديدة",
    "last30Days": "خلال آخر 30 يومًا",
    "activeUsers": "المستخدمون النشطون",
    "subscriptions": "الاشتراكات النشطة",
    "activeSubscriptions_zero": "لا توجد اشتراكات",
    "activeSubscriptions_one": "اشتراك واحد، بالريال العماني",
    "activeSubscriptions_two": "اشتراكان، بالريال العماني",
    "activeSubscriptions_few": "{{n}} اشتراكات، بالريال العماني",
    "activeSubscriptions_many": "{{n}} اشتراكًا، بالريال العماني",
    "activeSubscriptions_other": "{{n}} اشتراك، بالريال العماني",
    "openFeedback": "ملاحظات مفتوحة",
    "openFeedbackDetail": "جديدة وقيد المعالجة",
    "endingSoon": "تنتهي خلال 30 يومًا",
    "viewAll": "عرض الكل",
    "noneEnding": "لا ينتهي أي اشتراك نشط خلال الأيام الـ {{n}} القادمة.",
    "recentCompanies": "أحدث الشركات",
    "recentActivity": "أحدث نشاط للمشغّلين",
    "noActivity": "لا يوجد نشاط للمشغّلين بعد.",
    "ends": "ينتهي في {{date}}"
  },
  "subscriptions": {
    "title": "الاشتراكات",
    "intro": "ما تدفعه كل شركة. للتوثيق فقط، ولا يُفرض شيء.",
    "new": "اشتراك جديد",
    "newTitle": "اشتراك جديد",
    "editTitle": "تعديل الاشتراك",
    "dialogBody": "اختر الشركة وشروط الاشتراك.",
    "tenant": "الشركة",
    "pickTenant": "اختر شركة…",
    "pickerFailed": "تعذّر تحميل الشركات. حاول مرة أخرى.",
    "startDate": "تاريخ البدء",
    "endDate": "تاريخ الانتهاء",
    "endDateHint": "اتركه فارغًا لاشتراك مفتوح المدة.",
    "endBeforeStart": "لا يمكن أن يسبق تاريخ الانتهاء تاريخ البدء.",
    "amount": "المبلغ",
    "currency": "العملة",
    "status": "الحالة",
    "notes": "ملاحظات",
    "statuses": {
      "ACTIVE": "نشط",
      "PAST_DUE": "متأخر السداد",
      "CANCELLED": "ملغى",
      "EXPIRED": "منتهٍ"
    },
    "openEnded": "مفتوح المدة",
    "create": "إنشاء الاشتراك",
    "save": "حفظ الاشتراك",
    "created": "تمت إضافة اشتراك لـ {{name}}",
    "saved": "تم حفظ الاشتراك",
    "edit": "تعديل",
    "cancel": "إلغاء الاشتراك",
    "keep": "الإبقاء عليه",
    "cancelTitle": "إلغاء اشتراك {{name}}؟",
    "cancelBody": "يُعلَّم ملغى ويبقى في السجل. لا يتغيّر وصول الشركة.",
    "cancelled": "تم إلغاء الاشتراك",
    "searchPlaceholder": "ابحث عن شركة…",
    "searchLabel": "البحث في الاشتراكات",
    "endingSoon": "تنتهي خلال 30 يومًا",
    "tableLabel": "الاشتراكات",
    "empty": "لا توجد اشتراكات بعد.",
    "emptyFiltered": "لا توجد اشتراكات مطابقة.",
    "emptyTenant": "لا توجد اشتراكات لهذه الشركة.",
    "rowActions": "إجراءات اشتراك {{name}}"
  },
  "feedback": {
    "title": "الملاحظات",
    "intro": "ما أرسلته الشركات من تطبيقها.",
    "views": "الملاحظات حسب الحالة",
    "all": "الكل",
    "statuses": {
      "NEW": "جديدة",
      "IN_PROGRESS": "قيد المعالجة",
      "RESOLVED": "تم الحل",
      "CLOSED": "مغلقة"
    },
    "types": {
      "BUG": "خلل",
      "FEATURE_REQUEST": "طلب ميزة",
      "GENERAL": "عامة",
      "COMPLAINT": "شكوى"
    },
    "type": "النوع",
    "allTypes": "كل الأنواع",
    "subject": "الموضوع",
    "message": "الرسالة",
    "company": "الشركة",
    "sender": "المرسل",
    "status": "الحالة",
    "received": "تاريخ الاستلام",
    "searchPlaceholder": "ابحث في الموضوع أو الرسالة أو الشركة…",
    "searchLabel": "البحث في الملاحظات",
    "tableLabel": "الملاحظات",
    "empty": "لا توجد ملاحظات بعد.",
    "emptyFiltered": "لا توجد ملاحظات مطابقة.",
    "setStatus": "الحالة",
    "adminNote": "ملاحظة المشغّلين",
    "adminNoteHint": "لا يراها إلا المشغّلون.",
    "save": "حفظ",
    "saved": "تم تحديث الملاحظة"
  },
  "impersonation": {
    "label": "تم الدخول من لوحة إدارة المنصة",
    "banner": "أنت مسجّل الدخول باسم {{name}} ({{email}}) بواسطة مسؤول المنصة {{admin}} حتى {{time}}",
    "short": "جلسة مسؤول المنصة · حتى {{time}}",
    "end": "إنهاء الجلسة"
  },
  "feedbackForm": {
    "menu": "إرسال ملاحظة",
    "title": "إرسال ملاحظة",
    "body": "أبلغ عن مشكلة أو اقترح تحسينًا. يقرأ فريق سحاب كل رسالة.",
    "type": "النوع",
    "subject": "الموضوع",
    "message": "الرسالة",
    "submit": "إرسال",
    "sent": "تم إرسال الملاحظة",
    "sentBody": "شكرًا لك. سيتابعها فريق سحاب."
  },
  "residency": {
    "zone": {
      "OM": "عُمان",
      "GLOBAL": "عالمي"
    },
    "zoneBody": {
      "OM": "تبقى الملفات والبيانات في عُمان على استضافة داخل السلطنة.",
      "GLOBAL": "تُحفظ الملفات في النطاق العالمي للمنصة."
    },
    "requiresHosting": "يتطلب استضافة داخل السلطنة",
    "notConfigured": "لا تتوفر في هذا النشر مساحة تخزين لهذا النطاق.",
    "zonesUnknown": "تعذّرت قراءة النطاقات المتاحة في هذا النشر، وقد يُرفض نطاق عُمان عند إنشاء الشركة.",
    "title": "موقع البيانات",
    "body": "مكان حفظ ملفات هذه الشركة وبياناتها. لا ينقلها إلا مالك المنصة.",
    "current": "تُحفظ البيانات في",
    "move": "نقل البيانات",
    "moveActive": "هناك عملية نقل جارية. انتظر حتى تنتهي.",
    "noOtherZone": "لا يوفر هذا النشر نطاقًا آخر.",
    "ownerOnly": "لا ينقل بيانات الشركة إلا مالك المنصة.",
    "filesTitle": "الملفات حسب النطاق",
    "filesBody": "كل ملف محفوظ ومكانه الحالي.",
    "noFiles": "لا توجد ملفات لهذه الشركة بعد، وسيتغير النطاق فورًا عند النقل.",
    "zoneColumn": "النطاق",
    "filesColumn": "الملفات",
    "sizeColumn": "الحجم",
    "moveTitle": "آخر عملية نقل",
    "noMove": "لم تُنقل البيانات من قبل.",
    "route": "من {{from}} إلى {{to}}",
    "requestedBy": "بدأها {{name}}، {{date}}",
    "requestedOn": "بدأت {{date}}",
    "inProgress": "جارٍ نقل البيانات {{route}}…",
    "progress": "نُسخ {{copied}} من {{total}} ملفًا وتم التحقق منها",
    "uploadsPaused": "رفع الملفات متوقف لهذه الشركة حتى ينتهي النقل. تتحدث هذه الصفحة تلقائيًا.",
    "done": "نُقلت البيانات {{route}} في {{date}}: نُسخ {{total}} ملفًا وتم التحقق منها.",
    "failedTitle": "فشل النقل {{route}}",
    "failedBody": "{{reason}} بقيت كل الملفات في النطاق القديم ولم يُفقد شيء.",
    "failure": {
      "HASH_MISMATCH": "لم يطابق أحد الملفات المنسوخة الأصل.",
      "OTHER": "تعذّر إكمال النسخ."
    },
    "basisLabel": "الأساس النظامي:",
    "dialog": {
      "title": "نقل بيانات هذه الشركة",
      "body": "تُنسخ كل الملفات إلى نطاق آخر، ويُتحقق من كل نسخة، ثم يتغير النطاق.",
      "confirm": "بدء النقل",
      "toZone": "النقل إلى",
      "pickZone": "اختر مكان نقل البيانات.",
      "basis": "الأساس النظامي لنقل البيانات خارج عُمان",
      "basisHint": "يُحفظ في سجل المشغّلين، مثل بند العقد أو الموافقة الكتابية للعميل.",
      "basisNeeded": "اكتب الأساس النظامي ({{n}} أحرف على الأقل).",
      "slugMismatch": "اكتب عنوان الشركة كما هو ظاهر تمامًا.",
      "started": "بدأ النقل إلى {{zone}}",
      "whatHappens": "ما الذي سيحدث",
      "copy_zero": "لا توجد ملفات للنسخ.",
      "copy_one": "يُنسخ ملف واحد ويُتحقق من بصمته.",
      "copy_two": "يُنسخ ملفان ويُتحقق من بصمة كل منهما.",
      "copy_few": "تُنسخ {{n}} ملفات ويُتحقق من بصمة كل منها.",
      "copy_many": "يُنسخ {{n}} ملفًا ويُتحقق من بصمة كل منها.",
      "copy_other": "يُنسخ {{n}} ملف ويُتحقق من بصمة كل منها.",
      "paused": "يتوقف رفع الملفات لهذه الشركة حتى ينتهي النقل.",
      "flip": "لا يتغير النطاق إلا إذا طابقت كل النسخ الأصل، وإلا فلا يتغير شيء.",
      "typeSlug": "للتأكيد، اكتب"
    },
    "checkingZones": "جارٍ التحقق من توفره في هذا النشر…",
    "zoneUnchecked": "تعذّر التحقق من توفره في هذا النشر."
  },
  "messageUsage": {
    "title": "الرسائل المرسلة",
    "body": "رسائل البريد الإلكتروني التي سُلّمت لهذه الشركة خلال آخر 6 أشهر حسب القناة، لاحتساب الفوترة. لا تظهر هنا محتويات الرسائل ولا العناوين.",
    "empty": "لم تُرسل أي رسائل بعد",
    "emptyBody": "تظهر الأعداد هنا عندما ترسل الشركة أول رسالة بريد إلكتروني، مثل فاتورة أو دعوة.",
    "label": "الرسائل المرسلة شهرياً",
    "month": "الشهر",
    "channel": "القناة",
    "count": "الرسائل",
    "total": "الإجمالي، آخر 6 أشهر",
    "channels": {
      "email": "البريد الإلكتروني"
    }
  },
  "aiPolicy": {
    "title": "سياسة المساعد الذكي",
    "body": "السقف الشهري من الوحدات النصية (tokens) الذي يبقى حد الشركة دونه، والنماذج التي يمكنها اختيارها، والإيقاف المؤقت. وتدفع الشركة تكلفة OpenAI بنفسها عبر مفتاحها.",
    "none": "لا توجد سياسة للمساعد لهذه الشركة بعد، لذا فهو محجوب. احفظ سياسة للسماح به.",
    "suspendedNotice": "موقوف مؤقتًا",
    "adminOnly": "لا يغيّر سياسة المساعد إلا مسؤول المنصة.",
    "usedOf": "استُخدم {{used}} من {{cap}} وحدة نصية هذا الشهر ({{percent}})",
    "used": "استُخدم {{used}} وحدة نصية هذا الشهر",
    "meter": "الوحدات النصية المستخدمة هذا الشهر",
    "updated": "آخر تغيير {{date}}",
    "cap": "السقف الشهري من الوحدات النصية",
    "capHint": "يمكن للشركة ضبط حدّها الخاص عند هذا السقف أو دونه.",
    "capInvalid": "أدخل عددًا صحيحًا من الوحدات النصية حتى 10,000,000,000",
    "tokensUnit": "وحدة نصية شهريًّا",
    "models": "النماذج المسموح بها",
    "modelsHint": "معرّفات النماذج، مثل gpt-5-mini. إن لم يُذكر شيء: كل نماذج هذا النشر.",
    "modelsPlaceholder": "كل نماذج النشر",
    "modelsInvalid": "استخدم معرّف نموذج مثل gpt-5-mini",
    "checklistHint": "حدّد النماذج التي يمكن للشركة اختيارها. إن لم يُحدَّد شيء: كل نماذج هذا النشر.",
    "notOffered": "لم يعد هذا النشر يوفّره",
    "chips": {
      "remove": "إزالة {{value}}",
      "added": "أُضيف {{value}}. عدد النماذج: {{n}}.",
      "removed": "أُزيل {{value}}. عدد النماذج: {{n}}.",
      "limit": "{{max}} نموذجًا على الأكثر.",
      "notAdded": "لم يُضف {{n}}: الحد {{max}} نموذجًا."
    },
    "suspend": "إيقاف المساعد مؤقتًا لهذه الشركة",
    "suspendHint": "لا يستطيع أحد في الشركة استخدامه حتى يُستأنف من هنا، وتبقى إعداداته محفوظة.",
    "reason": "السبب",
    "reasonHint": "يظهر للمشغّلين ويُسجَّل في نشاط لوحة التحكم.",
    "reasonRequired": "اذكر سبب إيقاف المساعد",
    "save": "حفظ سياسة المساعد",
    "saved": "حُفظت سياسة المساعد",
    "areas": "المجالات",
    "areasHint": "ما يجوز للشركة استخدام المساعد فيه. المجال غير المحدد يظهر في إعدادات الشركة على أنه غير مسموح، وتُرفض تشغيلاته.",
    "areaNames": {
      "general": "المساعد في كل صفحة",
      "projects": "مساعد المشاريع",
      "accounting": "المساعد المحاسبي",
      "inventory": "مساعد المخزون",
      "purchasing": "مساعد المشتريات",
      "service": "مساعد الخدمة"
    },
    "areaHints": {
      "general": "يجيب من كل مجال مسموح هنا، في أي صفحة.",
      "purchasing": "يقرأ فواتير الموردين كاملة (صورًا وملفات PDF).",
      "service": "يجهّز المواقع وأماكنها ومعداتها؛ ويقرأ قوائم المعدات والمستندات (صورًا وملفات PDF)."
    },
    "areasNone": "لا مجال مسموح: لا تستطيع الشركة استخدام المساعد."
  }
}
